module.exports = __webpack_public_path__ + "static/media/line.1b222293.svg";